import { keyframes } from '@emotion/react';
var circleAnimation = keyframes({
    ' 0%': {
        transform: 'rotateZ(0deg)'
    },
    '66%': {
        transform: 'rotateZ(220deg)'
    },
    '100%': {
        transform: 'rotateZ(360deg)'
    }
});
var mediumTailChaserAnimation = keyframes({
    '0%': {
        strokeDashoffset: 100,
        transform: 'rotateZ(0deg)'
    },
    '50%': {
        strokeDashoffset: 0,
        transform: 'rotateZ(45deg)'
    },
    '100%': {
        strokeDashoffset: 100,
        transform: 'rotateZ(360deg)'
    }
});
var bigTailChaserAnimation = keyframes({
    '0%': {
        strokeDashoffset: 240,
        transform: 'rotateZ(0deg)'
    },
    '50%': {
        strokeDashoffset: 0,
        transform: 'rotateZ(45deg)'
    },
    '100%': {
        strokeDashoffset: 240,
        transform: 'rotateZ(360deg)'
    }
});
export var getStyle = function (theme) {
    return {
        outerContainer: {
            base: {
                fontFamily: theme.font.base.family,
                fontSize: theme.font.base.size.h4,
                fontWeight: theme.font.base.weight.regular,
                position: 'relative',
                overflow: 'visible',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                transformOrigin: '50% 50%',
                marginBottom: 16,
                flexGrow: 0,
                flexShrink: 0
            },
            big: {},
            inline: {
                flexDirection: 'row',
                marginBottom: 32,
                marginRight: 8
            }
        },
        circle: {
            base: {
                strokeDasharray: 600,
                animation: circleAnimation + " 3.773s linear infinite",
                transformOrigin: '50% 50%',
                overflow: 'visible',
                width: '78px',
                height: '78px',
                margin: 33,
                stroke: theme.backgroundColor.active,
                strokeLinecap: 'round',
                strokeWidth: '6px',
                fill: 'transparent'
            },
            big: {
                strokeDasharray: 900,
                width: '178px',
                height: '178px'
            },
            slow: {
                animation: circleAnimation + " 37.73s linear infinite"
            }
        },
        tailChaser: {
            base: {
                strokeDasharray: 175,
                animation: mediumTailChaserAnimation + "  2.45s linear infinite",
                transformOrigin: '50% 50%',
                strokeWidth: '6px',
                fill: 'transparent'
            },
            big: {
                animation: bigTailChaserAnimation + "  2.45s linear infinite",
                strokeDasharray: 400
            },
            slow: {
                animation: mediumTailChaserAnimation + "  24.5s linear infinite"
            },
            bigSlow: {
                animation: bigTailChaserAnimation + "  24.5s linear infinite"
            }
        },
        text: {
            base: {
                fontFamily: theme.font.base.family,
                fontSize: theme.font.base.size.h4,
                fontWeight: theme.font.base.weight.regular,
                color: theme.font.color.base,
                justifyContent: 'center',
                position: 'relative',
                textAlign: 'center',
                margin: 0,
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                height: 'auto'
            },
            inline: {
                display: 'inline-block',
                marginLeft: '8px'
            }
        },
        gradientColor1: theme.backgroundColor.accent.fill.base,
        gradientColor2: theme.backgroundColor.brand.fill.focus,
        gradientColor3: theme.backgroundColor.tertiary.fill.base
    };
};
